import React, {Component} from 'react';
import "./template_course_page.scss";
import VideoPlayButton from "../../../common_components/video_play_button/video_play_button";
import ReactPlayer from "react-player";

interface TemplateCoursePagePlaceholderProps {
    image?: string;
    video?: string;
    className?: string;
}

/**
 * The TemplatePagePlaceholder component shows the template page placeholder content on the desktop version,
 * which is optional and can be an image or a video
 */
class TemplateCoursePagePlaceholder extends Component<TemplateCoursePagePlaceholderProps> {

    state: {
        playing: boolean
    };

    constructor(props: Readonly<TemplateCoursePagePlaceholderProps>) {
        super(props);
        this.state = {
            playing: false
        }
    }

    render() {
        if (this.props.video) {
            let videoPars: { [key: string]: any } = {
                controls: this.state.playing,
                playing: this.state.playing,
                playsinline: true,
                className: this.props.className,
                onPause: () => this.setState({playing: false}),
                url: this.props.video,
                width: "100vw"
            };

            // if the editor has set a poster image, we render it
            if (this.props.image) {
                videoPars["light"] = this.props.image;
            }

            return (
                <div id="template-course-page"
                     className={"video u-video " + (this.state.playing ? "playing " : "") + this.props.className}>

                    <ReactPlayer {...videoPars} muted={false} playIcon={
                        <div className="play-button-container" onClick={() => this.setState({playing: true})}>
                            <VideoPlayButton startVideo={() => this.setState({playing: true})} />
                        </div>
                    }/>
                </div>
            )
        }

        if (this.props.image) {
            // The placeholder content is an image ----------------

            return <img key="template-page-placeholder" id="template-page-placeholder"
                        className={"image u-photo " + this.props.className} src={this.props.image} alt=""/>
        }

        // There is no placeholder content
        return <div />;
    }
}

export default TemplateCoursePagePlaceholder;
